<template>
    <div class="goods_list_container">
        <!-- 分类路径 -->
        <div class="level_nav_main">
            <div class="level_item" v-if="catePath.length">
                <!-- 一级分类，显示该部分 -->
                <template v-if="1===showIndex">
                    <div class='level_nav_item'>
                        <a class='level_link'>首页</a>
                    </div>
                    <i class="level-right"></i>
                    <div class="level_nav_item">
                        <div class="menu_drop">
                            <div class="trigger">
                                <span class="trigger_name">{{catePathName.path[0]}}</span>
                                <i class="menu_drop_arrow"></i>
                            </div>
                            <div class="menu_drop_main">
                                <ul class="menu_drop_list">
                                    <li v-for="({categoryName,categoryId},index) in cate1.cate" :key="index">
                                        <router-link :to="`/goods/list?categoryId=${categoryId}`">
                                            {{categoryName}}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 进入二级分类路径下的页面时，显示该部分 -->
                <template v-else-if="2===showIndex">
                    <div class="level_nav_item">
                        <div class="menu_drop">
                            <div class="trigger">
                                <span class="trigger_name">{{catePathName.path[0]}}</span>
                                <i class="menu_drop_arrow"></i>
                            </div>
                            <div class="menu_drop_main">
                                <ul class="menu_drop_list">
                                    <li v-for="({categoryName,categoryId},index) in cate1.cate" :key="index">
                                        <router-link :to="`/goods/list?categoryId=${categoryId}`">
                                            {{categoryName}}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <i class="level-right"></i>
                    <div class="level_nav_item">
                        <div class="menu_drop">
                            <div class="trigger">
                                <span class="trigger_name">{{catePathName.path[1]}}</span>
                                <i class="menu_drop_arrow"></i>
                            </div>
                            <div class="menu_drop_main">
                                <ul class="menu_drop_list">
                                    <li v-for="({categoryName,categoryId},index) in cate2.cate" :key="index">
                                        <a @click="goCate3(categoryId)">{{categoryName}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 进入三级分类路径下的页面时，显示该部分 -->
                <template v-else>
                    <div style="float: left;">
                        <div class="level_nav_item">
                            <div class="menu_drop">
                                <div class="trigger">
                                    <span class="trigger_name">{{catePathName.path[0]}}</span>
                                    <i class="menu_drop_arrow"></i>
                                </div>
                                <div class="menu_drop_main">
                                    <ul class="menu_drop_list">
                                        <li v-for="({categoryName,categoryId},index) in cate1.cate" :key="index">
                                            <router-link :to="`/goods/list?categoryId=${categoryId}`">
                                                {{categoryName}}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <i class="level-right"></i>
                        <div class="level_nav_item">
                            <div class="menu_drop">
                                <div class="trigger">
                                    <span class="trigger_name">{{catePathName.path[1]}}</span>
                                    <i class="menu_drop_arrow"></i>
                                </div>
                                <div class="menu_drop_main">
                                    <ul class="menu_drop_list">
                                        <li v-for="({categoryName,categoryId},index) in cate2.cate" :key="index">
                                            <router-link :to="`/goods/list?categoryId=${categoryId}`">
                                                {{categoryName}}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <i class="level-right"></i>
                        <div class="level_nav_item">
                            <div class="menu_drop">
                                <div class="trigger">
                                    <span class="trigger_name">{{catePathName.path[2]}}</span>
                                    <i class="menu_drop_arrow"></i>
                                </div>
                                <div class="menu_drop_main">
                                    <ul class="menu_drop_list">
                                        <li v-for="({categoryName,categoryId},index) in cate3.cate" :key="index">
                                            <a @click="goCate3(categoryId)">{{categoryName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="level_nav_item" style="margin-left: 10px;">
                    <div class="menu_drop" v-for="(item,index) in attriList" :key="index">
                        <div class="trigger" @click="attriKick(index)">
                            <span class="trigger_name">{{item}}</span>
                            <i class="menu_drop_arrow"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="level_item" v-show="keyword">
                <div class='level_nav_item' style="font-size: 13px;">
                    <a class='level_link'><i style="color: #e22319;">"{{keyword}}" &nbsp;</i>搜索结果</a>
                </div>
            </div>
        </div>
        <div class="goods_list_banner">
            <!-- 二级分类或者三级分类的组件 -->
            <GoodsListCate2 :cateItem="cate1.child" :cate2Name="catePathName.path[0]" v-show="showIndex===1">
            </GoodsListCate2>
            <GoodsListCate2 :cateItem="cate2.child" :cate2Name="catePathName.path[1]" v-show="showIndex===2">
            </GoodsListCate2>
            <GoodsListCate3 :categoryid="categoryId3" v-show="showIndex===3" @attriOption="attriOption">
            </GoodsListCate3>
        </div>

        <div class="goods_list clearfix">
            <!-- 筛选区域 -->
            <div class="sld_screen">
                <a @click="filterSort(0)" :class="0===indexNum?'btn_sort':'' ">{{L['综合']}}</a>
                <a @click="filterSort(1)" :class="1===indexNum?'btn_sort':'' ">{{L['销量']}}</a>
                <a @click="filterSort(2)" :class="2===indexNum?'btn_sort':'' ">{{L['评论数']}}</a>
                <a :class="{sld_price_jt_down:indexNum==3,sld_price_jt_up:indexNum==4}"
                    @click="filterSort(indexNum==4?3:4)">{{L['价格']}}</a>

                <div class="price_section on">
                    <div class="input_box">
                        <input type="number" min="0" class="sld_rmb" v-model="lowprice" id="lowprice">
                        <span class="line"></span>
                        <input type="number" min="0" class="sld_rmb" v-model="highprice" id="highprice">
                    </div>
                    <!-- 价格区间选定暂无方法 -->
                    <div class="ctrl clearfix">
                        <a class="fl clearVal" @click="reset">{{L['清空']}}</a>
                        <a class="fr confirm" @click="confirm">{{L['确定']}}</a>
                    </div>
                </div>
                <div class="goods_type">
                    {{L['商品类型']}}:
                    <p>
                        <input type="checkbox" :value="isOwnShop" id="isOwn" @input="filterStoreSelf(isOwnShop)"><label
                            for="isOwn">{{L['仅平台自营']}}</label>
                    </p>
                </div>
                <span class="sld_goods_num">{{goodsData.data.length}}件相关商品</span>
            </div>

            <!-- 商品列表 -->
            <ul :class="{sld_goods_list:true,skeleton_sld_goods_list:firstLoading}">
                <li v-for="({goodsName,goodsImage,goodsPrice,saleNum,activityList,isFollowGoods,defaultProductId},index) in (firstLoading?skeletonData.data:goodsData.data)"
                    :key="index">
                    <div class="sld_img sld_img_center">
                        <router-link target="_blank" :to="`/goods/detail?productId=${defaultProductId}`">
                            <img :src="goodsImage" alt="">
                        </router-link>
                    </div>
                    <p class="clearfix">
                        <span class="sld_goods_price fl">￥<em>{{goodsPrice}}</em></span>
                        <span class="fr">{{L['成交量']}} <em>{{saleNum}}</em></span>
                    </p>
                    <div class="sld_h32_hide">
                        <router-link class="sld_goods_name" target="_blank"
                            :to="`/goods/detail?productId=${defaultProductId}`">
                            <span v-html="goodsName"></span>
                        </router-link>
                    </div>
                    <a href="#" class="sld_vendor_name"></a>
                    <div class="tag">
                        <p class="fl">
                            <span class="tag_b" v-for="({promotionName},index) in activityList"
                                :key="index">{{promotionName}}</span>
                        </p>
                        <button class="sld_follow fr followGoods0" v-if="!isFollowGoods"
                            @click="collectGoods(defaultProductId,isFollowGoods)"><i
                                class="iconfont">&#xe612;</i>{{L['收藏']}}
                        </button>
                        <button class="sld_follow fr followGoods0" v-else
                            @click="collectGoods(defaultProductId,isFollowGoods)"><i><img
                                    src="../../assets/goods/collection.png" alt="" width="22"
                                    height="22"></i>{{L['已收藏']}}
                        </button>
                    </div>
                </li>
            </ul>
            <SldCommonEmpty v-show="isEmpty" />
        </div>

        <!-- 分页 -->
        <div class="flex_row_center_center sld_pagination">
            <el-pagination @prev-click="handlePrevCilickChange" @next-click="handleNextCilickChange"
                @current-change="handleCurrentChange" v-model:currentPage="goodsData.page.current"
                :page-size="goodsData.page.pageSize" layout="prev, pager, next, jumper" :total="goodsData.page.total"
                :hide-on-single-page="true">
            </el-pagination>
        </div>

        <SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" />
    </div>

</template>
<script>
    import { getCurrentInstance, onMounted, reactive, ref, watchEffect, watch } from 'vue';
    import { ElMessage } from 'element-plus'
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex";
    import GoodsListCate2 from './GoodsListCate2';
    import GoodsListCate3 from './GoodsListCate3';
    import SldLoginModal from "../../components/loginModal";
    import SldCommonEmpty from '../../components/SldCommonEmpty'

    export default {
        name: 'goodsList',
        components: {
            GoodsListCate2,
            GoodsListCate3,
            SldLoginModal,
            SldCommonEmpty
        },
        setup() {
            //变量------------------------------
            const firstLoading = ref(true);//是否第一次加载
            const skeletonData = reactive({ data: [] });
            const store = useStore();
            const loginModalVisibleFlag = ref(false);//登录弹框是否显示，默认不显示
            const initSkeletonData = () => {
                for (let i = 0; i < 10; i++) {
                    skeletonData.data.push({
                        goodsName: '',
                        goodsImage: '',
                        goodsPrice: '',
                        saleNum: '',
                        activityList: '',
                        isFollowGoods: '',
                        defaultProductId: '',
                    });
                }
            }
            initSkeletonData();
            const route = useRoute()
            const router = useRouter()
            const catePath = ref([])//导航路径
            const showIndex = ref(0)//显示flag
            const catePathName = reactive({ path: [] })                                         //需要在页面显示的整个分类路径
            const params = reactive({                                                           //初始化的请求参数
                current: 1,
            })
            const { proxy } = getCurrentInstance()
            const L = proxy.$getCurLanguage();
            const goodsData = reactive({ data: [], page: {} })
            const indexNum = ref(0)
            const lowprice = ref(null)
            const highprice = ref(null)
            const isEmpty = ref(false)
            const keyword = ref(route.query.keyword != undefined && route.query.keyword ? route.query.keyword : '');//搜索关键词
            const cate1 = reactive({ cate: {}, child: {} })
            const cate2 = reactive({ cate: {}, child: {} })
            const cate3 = reactive({ cate: {} })
            const categoryId3 = ref(route.query.categoryId != undefined && route.query.categoryId ? route.query.categoryId : '')
            const attriList = ref([])
            //方法------------------------------
            //初始化数据，进行请求
            const getInitData = (params) => {
                let searchParams = { ...params }
                proxy.$get('/v3/goods/front/goods/goodsList', searchParams).then(res => {
                    firstLoading.value = false;
                    if (res.state == 200) {
                        let result = res.data.list
                        goodsData.data = res.data.list
                        isEmpty.value = res.data.list.length ? false : true
                        goodsData.page = res.data.pagination
						if(!store.state.loginFlag){
							goodsData.data.forEach(item => {
							item.goodsPrice = "不可见"
							})
						}
                        if (goodsData.data.length) {
                            if (route.query.categoryId == result[0].categoryId1) {
                                catePath.value = [result[0].categoryId1]
                                showIndex.value = 1
                                getCatePathName()
                            }
                            else if (route.query.categoryId == result[0].categoryId2) {
                                catePath.value = [result[0].categoryId1, result[0].categoryId2]
                                showIndex.value = 2
                                getCatePathName()
                            } else if (route.query.categoryId == result[0].categoryId3) {
                                catePath.value = [result[0].categoryId1, result[0].categoryId2, result[0].categoryId3]
                                showIndex.value = 3
                                getCatePathName()
                            }

                        }
                    }
                })
            }

            const getCatePathName = () => {                                                     //获取分类Id数组对应的分类名
                let cateIdparams = {
                    categoryId1: catePath.value[0]                                                //获取该分类所属的一级分类Id
                }
                proxy.$get('/v3/goods/front/goods/category/list', cateIdparams).then(res => {                //通过一级分类Id去请求
                    if (res.state == 200 && catePath.value.length) {
                        let level1Path = res.data.list.find(item => item.categoryId == catePath.value[0])  //从请求返回结果寻找一级分类Id对应的一级分类名
                        cate1.cate = res.data.list.filter(item => item.categoryId != catePath.value[0])
                        cate1.child = level1Path.children ? level1Path.children : '' //一级分类下的二分级类
                        catePathName.path[0] = level1Path.categoryName //一级分类名
                        if (catePath.value[1]) {
                            let level2Path = level1Path.children.find(item => item.categoryId == catePath.value[1]) //从一级分类Id的children寻找二级分类Id对应的二级分类
                            cate2.cate = level1Path.children.filter(item => item.categoryId != catePath.value[1])//得除该二级分类外的其他二级分类
                            cate2.child = level2Path.children
                            catePathName.path[1] = level2Path.categoryName//二级分类名
                            if (catePath.value[2] == route.query.categoryId) {                                               //如果在商品分类点击的是三级分类，表明catePath[2]不为undefined
                                let level3Path = level2Path.children.find(item => item.categoryId == catePath.value[2])  //从二级分类Id的children寻找三级分类Id对应的三级分类名
                                cate3.cate = level2Path.children.filter(item => item.categoryId != catePath.value[2])//得除该三级分类外的其他三级分类
                                catePathName.path[2] = level3Path.categoryName//三级分类名
                            }
                        }

                    }
                });
            }

            const goCate3 = (categoryId) => {
                router.push({
                    path: 'list',
                    query: {
                        categoryId: categoryId
                    }
                })
                getCatePathName()
            }
            const handlePrevCilickChange = (e) => {                //页数改变的方法
                params.current = e
                getInitData(params)
            }

            const handleNextCilickChange = (e) => {
                params.current = e
                getInitData(params)
            }
            const handleCurrentChange = (e) => {
                params.current = e
                getInitData(params)
            }

            const filterSort = (index) => {
                indexNum.value = index
                params.sort = index
                getInitData(params)

            }

            const isOwnShop = ref(false)
            const filterStoreSelf = (e) => {                           //商品是否自营
                isOwnShop.value = !e
                params.isSelf = isOwnShop.value ? 1 : 0;
                getInitData(params)
            }

            const confirm = () => {                               //价格区间确认按钮
                if (lowprice.value > highprice.value) {
                    ElMessage.warning({
                        message: '最低价格应小于最高价格',
                        type: 'warning'
                    });
                    lowprice.value = null
                    highprice.value = null
                } else {
                    params.highPrice = highprice.value
                    params.lowPrice = lowprice.value
                    getInitData(params)
                }
            }

            const reset = () => {                                //价格区间清空按钮
                lowprice.value = null
                highprice.value = null
                params.highPrice = highprice.value
                params.lowPrice = lowprice.value
                getInitData(params)
            }

            //收藏及取消收藏商品
            const collectGoods = (defaultProductId, isFollowGoods) => {
                if (store.state.loginFlag) {  //已登录
                    let params = {
                        productIds: defaultProductId,
                        isCollect: !isFollowGoods
                    }
                    proxy.$post("v3/member/front/followProduct/edit", params).then((res) => {
                        if (res.state == 200) {
                            ElMessage.success(res.msg);
                            goodsData.data.map(goodsItem => {
                                if (goodsItem.defaultProductId == defaultProductId) {
                                    goodsItem.isFollowGoods = !isFollowGoods;
                                }
                            })

                        } else {
                            ElMessage.error(res.msg);
                        }
                    });
                } else {
                    //未登录提示登录
                    loginModalVisibleFlag.value = true;
                }
            };
            //关闭登录弹框
            const closeLoingModal = () => {
                loginModalVisibleFlag.value = false;
            };

            const attriOption = (attributeName, attributeValue) => {//添加属性查询
                let attriInfo = `${attributeName}_${attributeValue}`
                attriList.value.push(attriInfo)

                params.attributeInfo = attriList.value.join(',')
                proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
                    goodsData.data = res.data.list
                })
            }

            const attriKick = (index) => {//删除属性查询
                attriList.value.splice(index, 1)
                if (attriList.value.length) {
                    params.attributeInfo = attriList.value.join(',')
                    proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
                        goodsData.data = res.data.list
                    })
                } else {
                    delete params.attributeInfo
                    proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
                        goodsData.data = res.data.list
                    })
                }


            }

            watchEffect(() => {
                if (route.query.keyword != undefined) {
                    keyword.value = route.query.keyword;
                    categoryId3.value = ""
                    catePath.value = []
                    params.keyword = keyword.value
                    getInitData(params)

                } else if (route.query.categoryId != undefined) {
                    categoryId3.value = route.query.categoryId;
                    keyword.value = "";
                    params.categoryIds = route.query.categoryId
                    getInitData(params)

                }
            });


            watch(() => route.query.categoryId, (nv, ov) => {
                if (nv != ov) {
                    categoryId3.value = nv
                }

            })

            onMounted(() => {
                let params = {};
                params.current = 1
                if (route.query.categoryId) {
                    params = {
                        categoryIds: route.query.categoryId
                    }
                } else if (route.query.brandId) {
                    params = {
                        brandIds: route.query.brandId
                    }
                } else if (route.query.keyword) {
                    params = {
                        keyword: route.query.keyword
                    }
                }
                getInitData(params)
            })

            //返回
            return {
                goodsData,
                handlePrevCilickChange,
                handleNextCilickChange,
                handleCurrentChange,
                L,
                catePathName,
                catePath,
                showIndex,
                indexNum,
                filterSort,
                filterStoreSelf,
                isOwnShop,
                lowprice,
                highprice,
                confirm,
                reset,
                isEmpty,
                keyword,
                cate1,
                cate2,
                cate3,
                firstLoading,
                skeletonData,
                collectGoods,
                loginModalVisibleFlag,
                closeLoingModal,
                goCate3,
                categoryId3,
                attriOption,
                attriList,
                attriKick
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/goodsList.scss';
    @import '../../style/base.scss';

    input[type="checkbox"] {
        display: none;
        vertical-align: middle;
        margin-bottom: 3px;
        margin-right: 3px;
    }

    input[type="checkbox"]+label {
        background: url('../../assets/goods/unsel.png') left center no-repeat;
        padding-left: 20px;
        background-size: 12px 12px;
    }

    input[type="checkbox"]:checked+label {
        background-image: url('../../assets/goods/select.png');
    }

    .empty_page {
        flex-direction: column;
        padding: 100px;
    }
</style>